
export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-teal-50 text-teal-700 rounded-full text-sm font-semibold mb-6">
              Cash Land Buyers Near Me
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>
              We Buy Land for Cash in El Paso & Southern New Mexico
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              TRex RE LLC - The Texas Property buyers has been helping landowners sell their vacant land quickly and hassle-free since 2016. Whether you own a small residential lot, agricultural acreage, or commercial land, we make fair cash offers and close on your timeline.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Unlike traditional real estate agents who list your land and wait for months (or years) to find a buyer, we are direct cash buyers. That means no commissions, no listing fees, no showings, and no uncertainty. We buy land in any condition, with or without utilities, access issues, zoning problems, or <a href="/title-issues" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">title complications</a>.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our mission is simple: to provide landowners with a fast, transparent, and fair way to sell vacant land without the headaches of the traditional market. We specialize in buying unwanted property, <a href="/inherited-homes" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">inherited land</a>, land with back taxes, and properties that other buyers won't touch. As <a href="/elpaso-tx" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso's local property buyers</a>, we also help homeowners <a href="/avoid-foreclosure" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">avoid foreclosure</a> and <a href="/rental-property" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">sell rental properties</a>. Stay updated with <a href="/local-news-el-paso-texas" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">El Paso real estate news</a>.
            </p>
            <div className="flex items-center space-x-4">
              <a href="tel:+1-915-206-5814" className="inline-flex items-center space-x-2 px-6 py-3 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill"></i>
                <span>Get Your Cash Offer</span>
              </a>
              <div className="text-sm text-gray-600">
                <strong>Over 200+</strong> land parcels purchased
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/aecb64409c504df6db4b913408921f49.jpg"
                alt="Cash land buyers evaluating property"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-teal-600 text-white p-6 rounded-lg shadow-xl">
              <div className="text-3xl font-bold mb-1">24 Hours</div>
              <div className="text-sm">Average Offer Time</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
